import React, { FC } from 'react';
import Typography from '@mui/material/Typography';

import { Modal } from 'src/shared/components/Modal/Modal';
import { useTranslate } from 'src/shared/providers';

export const ConfirmDeleteFileModal: FC<{
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileName: string;
  isLoading?: boolean;
}> = ({ open, isLoading, onClose, onConfirm, fileName }) => {
  const { t } = useTranslate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      modalHeaderProps={{
        title: t('messageCenter.removeAttachments'),
        onClose,
      }}
      modalFooterProps={{
        submitText: t('global.remove'),
        loading: isLoading,
        closeText: t('global.cancel'),
        onSubmit: onConfirm,
        onClose,
      }}
    >
      <Typography variant="body2">{t('messageCenter.areYouSureYouWantToRemoveName', { name: fileName })}</Typography>
    </Modal>
  );
};
